import React from 'react';
import styles from './styles.module.scss';

interface RecipientItemProps {
  email: string;
  deleteSigner: (signerId: string) => Promise<void>;
}

const RecipientItem = ({ email, deleteSigner }: RecipientItemProps) => {
  return (
    <div className={styles.recipientPill}>
      <span className={styles.emailText}>{email}</span>
      <button
        className={styles.removeButton}
        onClick={() => deleteSigner(email)}
        type="button"
        aria-label={`Remove ${email}`}
      >
        ×
      </button>
    </div>
  );
};

export default RecipientItem;
